import React, {FC, useEffect, useState} from 'react';
import styles from "./BuoysPage.module.scss"
import {deleteBuoysRelations, getBuoysRelations} from "../../api";
import Alert from "react-bootstrap/Alert";
import {BuoyDeployment, BuoyDeploymentRelation, Deployment} from "../../dtos/dtos";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import Select from "react-select";


interface BuoysPageProps {
    jobs: Deployment[]
}

const BuoysPage: FC<BuoysPageProps> = (props) => {
    const [errorMsg, setErrorMsg] = useState<string>();
    const [buoyRelations, setBuoyRelations] = useState<BuoyDeployment[]>([]);
    const [showDeleteConfirmation, setShowDeleteConfirmation] = useState<boolean>(false);
    const [selected, setSelected] = useState<BuoyDeployment>();
    const [deploymentsOptions, setDeploymentsOptions] = useState<{value: string, label: string}[]>([]);
    const [newAssociationBuoy, setNewAssociationBuoy] = useState<string>("");
    const [newAssociationDeployment, setNewAssociationDeployment] = useState<{ value: string, label: string }>();
    const [showNewAssociationConfirmation, setShowNewAssociationConfirmation] = useState<boolean>(false);

    useEffect(() => {
        fetchBuoyRelations()
    },[])

    useEffect(() => {
        console.log(props)
        setDeploymentsOptions((props.jobs || []).map(x => ({value: x.id, label: x.name})))
    },[props.jobs])

    const fetchBuoyRelations = () => {
        getBuoysRelations().then(payload => {
            setBuoyRelations(payload.data)
        });
    }

    const deleteClicked = (buoyRelation: BuoyDeployment) => {
        setSelected(buoyRelation);
        setShowDeleteConfirmation(true);
    }

    const addAssociation = () => {
        setShowNewAssociationConfirmation(true);
    }

    return (
        <div className={styles.buoysPage + ' box'}>
            <h1>Buoy Deployments</h1>
            <h5>This page allows the management of the relationship between buoy and deployments. If a relation exists between the two, all
                data sent from the buoy will be associated with that deployment</h5>
            <hr />
            <h3>Asscociations</h3>
            <div className={styles.newAssociation}>
                <div className={styles.depl}>
                    <label>Deployment</label>
                    <Select
                        onChange={x => setNewAssociationDeployment(x as { value: string, label: string })}
                        defaultValue={newAssociationDeployment}
                        options={deploymentsOptions}
                        // onBlur={triggerTextUpdated}
                        // onKeyDown={event => event.key === 'Enter' && endEditMode()}
                        isSearchable={true}
                        isMulti={false}
                        isClearable={false}
                    />
                </div>
                <div className={styles.buoy}>
                    <label>Buoy</label>
                    <input value={newAssociationBuoy} onChange={event => setNewAssociationBuoy(event.target.value)}/>
                </div>
                <Button variant="primary" size="sm" disabled={newAssociationBuoy.length > 0 && !!newAssociationDeployment?.value} onClick={() => addAssociation()}>Add Association</Button>
            </div>
            <table>
                <thead>
                <tr>
                <th>Buoy</th>
                    <th>Deployment</th>
                    <th>Actions</th>
                </tr>
                </thead>
                <tbody>
                {buoyRelations.map((buoyRelation) => (
                    <tr key={buoyRelation.buoyId + buoyRelation.deploymentId}>
                        <td>{buoyRelation.buoyId}</td>
                        <td>{buoyRelation.deployment.name}</td>
                        <td><Button variant="danger" size="sm" onClick={() => deleteClicked(buoyRelation)}>Delete</Button></td>
                    </tr>
                ))}
                </tbody>
            </table>
            { errorMsg && <Alert variant="danger">{errorMsg}</Alert> }

            <Modal show={showDeleteConfirmation} onHide={() => setShowDeleteConfirmation(false)} backdrop="static">
                <Modal.Header closeButton>
                    <Modal.Title>Delete Relation?</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <p>Do you really want to delete the relation between <span className={styles.emphasize}>{selected?.buoyId}</span> and <span className={styles.emphasize}>{selected?.deployment.name}</span>?</p>
                    <p>This will only delete the relation, but NOT the deployment NOR the collected data. This effect is that
                        the buoy will no longer send data to the deployment, but a new deployment will be created if no new associations
                        is created when buoy sends data.
                    </p>
                    <Alert variant="danger">This cannot be undone, so be absolutely certain you want to do this.</Alert>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="primary" onClick={() => setShowDeleteConfirmation(false)}>
                        Cancel
                    </Button>
                    <Button variant="danger" onClick={() => {
                        deleteBuoysRelations({ buoyId: selected?.buoyId, deploymentId: selected?.deploymentId } as BuoyDeploymentRelation).then(
                            x => fetchBuoyRelations(),
                            errorMsg => setErrorMsg(errorMsg?.message || "Unkown error occurred on deletion"));
                        setShowDeleteConfirmation(false);}
                    }>Delete</Button>
                </Modal.Footer>
            </Modal>

            <Modal show={showNewAssociationConfirmation} onHide={() => setShowNewAssociationConfirmation(false)} backdrop="static">
                <Modal.Header closeButton>
                    <Modal.Title>Add new association?</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <p>Do you want to add a new association between <span className={styles.emphasize}>{newAssociationBuoy}</span> and <span className={styles.emphasize}>{newAssociationDeployment?.label}</span>?</p>
                    <p>This means that all data sent from the buoy will be associated with that deployment.</p>
                    { buoyRelations.find(x => x.buoyId === newAssociationBuoy || x.deploymentId === newAssociationDeployment?.value) &&
                        <Alert variant="danger">
                            <p>
                                This will cause the following associations to be deleted. This cannot be undone. Only the relation(s) will be
                                deleted - the deployment and all the previously associated measurements will be kept.
                            </p>
                            <p>
                                { (buoyRelations.filter(x => x.buoyId === newAssociationBuoy || x.deploymentId === newAssociationDeployment?.value)).map(x =>
                                    <div>{x.deployment.name} with buoy {x.buoyId}</div>
                                )}
                            </p>
                        </Alert>
                    }
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="primary" onClick={() => setShowNewAssociationConfirmation(false)}>
                        Cancel
                    </Button>
                    <Button variant="danger" onClick={() => {
                        deleteBuoysRelations({ buoyId: selected?.buoyId, deploymentId: selected?.deploymentId } as BuoyDeploymentRelation).then(
                            x => fetchBuoyRelations(),
                            errorMsg => setErrorMsg(errorMsg?.message || "Unkown error occurred on deletion"));
                        setShowNewAssociationConfirmation(false);}
                    }>Delete</Button>
                </Modal.Footer>
            </Modal>
        </div>
    );
}

export default BuoysPage;
